export const formatStaffForJobPayload = (workforce) => {
  const roles = ["employees", "contractors", "supervisors"];

  return roles.flatMap((roleKey) =>
    (workforce[roleKey] || []).map((member) => ({
      uid: member.uid,
      role: member.type, // "employee", "contractor", or "supervisor"
    }))
  );
};
